import { render, staticRenderFns } from "./contentCourseLectureArticle.vue?vue&type=template&id=5a27f8a6&"
import script from "./contentCourseLectureArticle.vue?vue&type=script&lang=js&"
export * from "./contentCourseLectureArticle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports